var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirulo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 58,
    fill: "url(#paint0_linear_135_216)",
    fillOpacity: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_216",
    x1: 10.5,
    y1: 21,
    x2: 97.5,
    y2: 103.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A50C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288462,
    stopColor: "#C03387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#DD2F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC367"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirulo);
export default __webpack_public_path__ + "static/media/cirulo.a6e99c9602911aeccb1875446476d5a9.svg";
export { ForwardRef as ReactComponent };